/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CalculatorIcon32Regular = forwardRef('CalculatorIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M10.5 9a1 1 0 1 0 0 2h11a1 1 0 1 0 0-2h-11Z" }),
        React.createElement("path", { d: "M12 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M11 23a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
        React.createElement("path", { d: "M17 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M16 23a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
        React.createElement("path", { d: "M22 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M21 23a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5 2A5.5 5.5 0 0 0 5 7.5v17a5.5 5.5 0 0 0 5.5 5.5h11a5.5 5.5 0 0 0 5.5-5.5v-17A5.5 5.5 0 0 0 21.5 2h-11ZM7 7.5A3.5 3.5 0 0 1 10.5 4h11A3.5 3.5 0 0 1 25 7.5v17a3.5 3.5 0 0 1-3.5 3.5h-11A3.5 3.5 0 0 1 7 24.5v-17Z" })));
});
